import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/playlist/importer/playlistImporterActions'

export default importerReducers(actions)
